import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { ProductSearchResponse } from './../sheared/entities/productSearchResponse';
import { ProductSearchService } from './../services/productSearch.service';
import { TypeaheadMatch } from "../sheared/ngx-bootstrap";

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  public inputValue: string;
  public typeaheadNoResults: boolean;
  public dataSource: Observable<ProductSearchResponse>;
  public model: any;
  public debounceTime: number;
  ngOnInit() {
  }
  public constructor(private productSearchService: ProductSearchService) {
    this.dataSource = Observable
      .create((observer: any) => {
        observer.next(this.inputValue);
      })
      .mergeMap((token: string) => this.productSearchService.getFiltered(token));
    this.debounceTime = 50;
  }
  public typeaheadOnSelect(e: TypeaheadMatch): void {
    var redirectUrl = this.encodeUrl(e.item.Url);
    window.location.href = redirectUrl;
  }
  public onEnterPress(): void {
    var redirectUrl = this.encodeUrl("/sok/" + this.inputValue);
    window.location.href = redirectUrl;
  }
  private encodeUrl(value: string): string {
    var result = value.replace(/[ ]{1,}/g, '-');
    return result;
  }

  public fuzzyFiltering(result: string): string {
    result = this.fuzzyHighlight(result, this.inputValue);
    return result;
  }
  private processString(text: string): string {
    var result = text;
    while (result.indexOf(" ") != -1) {
      result = result.replace(" ", "");
    }
    while (result.indexOf("-") != -1) {
      result = result.replace("-", "");
    }
    return result;
  }
  public fuzzyHighlight(text: string, search: string): string {
    var searchString = this.processString(search).toLowerCase();
    if (searchString.length < 3) {
      return this.lowFuzzyHighlight(text, searchString);
    }
    var lowerText = text.toLowerCase();
    var searchArray = searchString.split("");
    var tokens = [];
    for (var i = 0; i < lowerText.length; i++) {
      var isEntered = false;
      var subString = "";
      var k = 0;
      for (var j = 0; j < searchArray.length && i < lowerText.length; j++) {
        if ((lowerText[i + k] == ' ' || lowerText[i + k] == '-') &&
            lowerText[i + k + 1] && lowerText[i + k + 1] == searchArray[j] && isEntered) {
          subString += lowerText[i + k];
          k++;
        }
        if (lowerText[i + k] != searchArray[j] && isEntered && lowerText[i + k]) {
          tokens.push(subString);
          subString = "";
          isEntered = false;
          k = 0;
        }
        if (lowerText[i + k] == searchArray[j] && lowerText[i + k]) {
          isEntered = true;
          subString += lowerText[i + k];
          k++;
        }
      }
      if (subString.length > 0) {
        tokens.push(subString);
      }
    }
    var tokenIndexs = [];
    tokens.sort((a: string, b: string) => {
      if (a.length < b.length) {
        return 1;
      }
      if (a.length > b.length) {
        return -1;
      }
      return 0;
    });

    var response = text.toLowerCase();
    for (var i = 0; i < tokens.length; i++) {
      if (searchString.length < 1) {
        break;
      }
      var processTokenString = this.processString(tokens[i]);
      var responseIndexOfToken = response.indexOf(tokens[i]);
      var textIndexOfToken = text.toLowerCase().indexOf(tokens[i]);
      var substringIndex = searchString.indexOf(processTokenString);
      if (responseIndexOfToken == -1 || substringIndex == -1) {
        continue;
      }
      for (var g = 0; g < tokens[i].length; g++) {
        tokenIndexs.push(textIndexOfToken + g);
      }
      response = response.replace(tokens[i], "");
      searchString = searchString.replace(processTokenString, "");
    }

    var result = text.split("");
    for (var n = 0; n < tokenIndexs.length; n++) {
      result[tokenIndexs[n]] = '<b>' + result[tokenIndexs[n]] + '</b>';
    }
    return result.join('');
  }
  public lowFuzzyHighlight(text: string, search: string): string {
    var searchArray = search;
    var tokens = this.processString(text).split("");
    var isHighlighted = false;
    for (var n = 0; n < tokens.length - 1 && !isHighlighted; n++) {
      if (tokens[n].toLowerCase() == searchArray[0] && tokens[n + 1].toLowerCase() == searchArray[1]) {
        tokens[n] = '<b>' + text[n] + '</b>';
        tokens[n + 1] = '<b>' + text[n + 1] + '</b>';
        isHighlighted = true;
      }
    }
    for (var i = 0; i < tokens.length && !isHighlighted; i++) {
      if (tokens[i].toLowerCase() == searchArray[0] || tokens[i].toLowerCase() == searchArray[1]) {
        tokens[i] = '<b>' + tokens[i] + '</b>';
        isHighlighted = true;
      }
    }
    return tokens.join('');
  }
}





// WEBPACK FOOTER //
// C:/websites/emusic-search-WA/emusic2018/emusic2018/SPA/src/app/serchComponent/search.component.ts